import { ButtonTriggerEvent } from '../../../common/components';

export class PlaceDetailsModalActions {
    confirm: (event: ButtonTriggerEvent, progressCallback?: (progress) => void) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/place.details.modal.provider.ts